import * as z from 'zod';

import { organizationTypeQuerySchema } from './organization-type-query-schema';

export const organizationTypeUpdateSchema = organizationTypeQuerySchema
  .pick({ id: true, name: true, plural: true })
  .extend({ status: z.string() });
export type OrganizationTypeUpdateSchema = z.infer<typeof organizationTypeUpdateSchema>;

export const organizationTypeCreateSchema = organizationTypeUpdateSchema.omit({
  id: true,
});
export type OrganizationTypeCreateSchema = z.infer<typeof organizationTypeCreateSchema>;
